import { Box } from '@material-ui/core';
import { alpha, styled } from '@material-ui/core/styles';

export const FormFields = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  width: '100%',
  marginBottom: 12,
});

export const FooterActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 16,
  marginTop: 32,
});

export const InheritanceAlert = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12,
  padding: '12px 16px',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
}));

export const PlaceholderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 200,
  color: theme.palette.text.secondary,
}));
